import { Modal, Table, Tag, Typography } from 'antd'
import { useFfsStrategy } from 'features/indicationTriage/cards/ffsCalc/ffsStrategyContext/FfsStrategyContext'
import React, { FC, useMemo } from 'react'
import styled from 'styled-components'

import { RESULT_OUTCOME_COLORS } from './ffsLtaPublishApi'
import { FfsResultType } from './ffsTypes'

const { Text } = Typography

const ModalContent = styled.div`
  padding: 0.5rem 0;
`

const IntroText = styled(Text)`
  font-size: 0.875rem;
  display: block;
  margin-bottom: 1.5rem;
  line-height: 1.5;
`

const StyledTable = styled(Table)`
  .ant-table {
    font-size: 0.875rem;
  }
`

const ResultTag = styled(Tag)<{ $resultType: FfsResultType }>`
  background-color: ${({ $resultType }) => RESULT_OUTCOME_COLORS[$resultType]};
  color: white;
  border: none;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  margin: 0;
`

export interface FfsResultCriteriaModalProps {
  open: boolean
  onClose: () => void
}

export const FfsResultCriteriaModal: FC<FfsResultCriteriaModalProps> = ({
  open,
  onClose,
}) => {
  const {
    strategy: { analysisResult },
  } = useFfsStrategy()

  const columns = [
    {
      title: 'Result',
      dataIndex: 'resultType',
      key: 'resultType',
      width: 80,
      render: (resultType: FfsResultType) => (
        <ResultTag $resultType={resultType}>{resultType}</ResultTag>
      ),
    },
    {
      title: 'Conditions',
      dataIndex: 'condition',
      key: 'condition',
      width: 200,
    },
    {
      title: 'Description',
      dataIndex: 'explanation',
      key: 'explanation',
    },
  ]

  const ffsResultCases = useMemo(() => {
    return analysisResult.getFfsResultCases()
  }, [analysisResult])

  return (
    <Modal
      title='FFS Analysis Result Criteria'
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}>
      <ModalContent>
        <IntroText>
          Analysis based on API-579 criteria for determining equipment fitness
          for service.
        </IntroText>

        <StyledTable
          columns={columns}
          dataSource={ffsResultCases}
          rowKey='resultId'
          pagination={false}
          size='small'
        />
      </ModalContent>
    </Modal>
  )
}
